import { render, staticRenderFns } from "./myBanner2.vue?vue&type=template&id=2346e5e1&scoped=true&"
import script from "./myBanner2.vue?vue&type=script&lang=js&"
export * from "./myBanner2.vue?vue&type=script&lang=js&"
import style0 from "./myBanner2.vue?vue&type=style&index=0&id=2346e5e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2346e5e1",
  null
  
)

export default component.exports